import React, {useEffect} from 'react';
import h from 'react-hyperscript';
import {h2, p} from 'Components/Typography/Typography';
import content from 'Assets/data/globals.json';

export default function ErrorPage(props) {
  const [title, setTitle] = React.useState('');
  const [desc, setDesc] = React.useState('');
  const [href, setHref] = React.useState('');
  const [alt, setAlt] = React.useState('');
  const [text, setText] = React.useState('');
  const {
    errorType,
  } = props;

  useEffect(() => {
    switch (errorType) {
      case 'nonEdu':
        setTitle(content.errorPage.notAuthorized.title);
        setDesc(content.errorPage.notAuthorized.desc);
        setHref(content.errorPage.notAuthorized.href);
        setAlt(content.errorPage.notAuthorized.alt);
        setText(content.errorPage.notAuthorized.text);
        break;
      case 'cookie':
        setTitle(content.errorPage.cookie.title);
        setDesc(content.errorPage.cookie.desc);
        setHref(content.errorPage.cookie.href);
        setAlt(content.errorPage.cookie.alt);
        setText(content.errorPage.cookie.text);
        break;
      case 'timeout':
        setTitle(content.errorPage.timeout.title);
        setDesc(content.errorPage.timeout.desc);
        setHref(content.errorPage.timeout.href);
        setAlt(content.errorPage.timeout.alt);
        setText(content.errorPage.timeout.text);
        break;
    }
  }, []);


  return (
    h('main', {
      className: 'page',
    }, [
      h('div', {
        className: 'container flex--wrap-all error-message',
      }, [
        h(h2, {
          key: 'error-title__key',
          className: 'text--grey text--center',
        }, title),
        h(p, {
          className: 'text--center text--grey padding-bottom--md',
        }, [
          desc,
          h('a', {
            href,
            alt,
            target: '_blank',
          }, text),
        ]),
      ]),
    ])
  );
}
